// module exports must be returned from runtime so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__(315);
return __webpack_require__(701);
